import React from 'react';
import MaterialIcon from 'react-native-vector-icons/MaterialIcons';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import AntDesign from 'react-native-vector-icons/AntDesign';
import FontAwesome from 'react-native-vector-icons/FontAwesome';

import { Tooltip } from '../Tooltip';

const Icon = (props) => {

  const _renderIcon = () =>{
    if (props.library == 'MaterialCommunityIcons') {
      return <MaterialCommunityIcons {...props} />
    } else if (props.library == 'AntDesign') {
      return <AntDesign {...props} />
    } else if (props.library == 'FontAwesome') {
      return <FontAwesome {...props} />
    } else {
      return <MaterialIcon {...props} />
    }
  }

  return (
    <Tooltip hidden={props.tooltipText ? false : true} text={props.tooltipText} onChangeHover={props.onChangeHover}>
     {_renderIcon()}
    </Tooltip>
  )
}

export default Icon;
